/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";

function rateConsumerInteraction(
  recycler_uid: string,
  recycler_location_uid: string,
  employee_uid: string,
  consumer_uid: string,
  conversation_uid: string,
  rating: number
) {
  return new Promise(function (resolve, reject) {

    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      firebase_email: window.G_firebase_auth.IV_email_address,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      employee_uid: employee_uid,
      consumer_uid: consumer_uid,
      conversation_uid: conversation_uid,
      p1s3e8_rating: rating,
    };

    ajax({
      url: window.G_cloud_p1s3_base_url + "p1s3e8RateConsumerInteraction",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,

      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },

      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s3e8.ts",
          class_name: "p1s3e8",
          method_name: "rateConsumerInteraction",
          error_title: "Failed to rate the conversation.",
          error_description:
            "The server responded with an error when trying to create an employee invite",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default rateConsumerInteraction;
